import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Auth} from '../actions/auth.actions';
import {LineItemsActions} from '../actions/lineItems.actions';
import {LineItemsService} from '../services/lineItems.service';
import {JobLineItems} from '../models/line.items/jobLineItems.model';
import ClearState = Auth.ClearState;
import UpdateLineItems = LineItemsActions.UpdateLineItems;
import GetLineItems = LineItemsActions.GetLineItems;

export interface LineItemsStateModel {
  jobLineItems: {
    id: string;
    lineItems: any[]
  } | null;
}

@State<LineItemsStateModel>({
  name: 'lineItems',
  defaults: {
    jobLineItems: null,
  }
})
@Injectable()
export class LineItemsState {
  constructor(private lineItemsService: LineItemsService
  ) {
  }

  @Selector()
  static lineItems(state: LineItemsStateModel): JobLineItems {
    return state.jobLineItems;
  }

  @Action(UpdateLineItems)
  updateLineItems(ctx: StateContext<LineItemsStateModel>, action: UpdateLineItems): Observable<JobLineItems> {
    return this.lineItemsService.updateLineItems(action.id, action.lineItems).pipe(
      tap(jobLineItems => {
        ctx.patchState({
          jobLineItems
        });
      })
    );
  }

  @Action(GetLineItems)
  getLineItems(ctx: StateContext<LineItemsStateModel>, action: GetLineItems): Observable<JobLineItems> {
    if (!action.force) {
      const lineItems = ctx.getState().jobLineItems;
      if (lineItems !== null && action.id === ctx.getState().jobLineItems.id) {
        return of(lineItems);
      }
    }
    return this.lineItemsService.getLineItems(action.id).pipe(
      tap(jobLineItems => {
        ctx.patchState({
          jobLineItems
        });
      })
    );
  }

  @Action(ClearState)
  clearState(ctx: StateContext<LineItemsStateModel>): void {
    ctx.setState({
      jobLineItems: null
    });
  }
}
